export default __webpack_public_path__ + "static/media/helper.984b608c.png";